import { useMemo } from "react";
import PropTypes from "prop-types";

import { useCurrentCountryCode } from "../../../hooks/usePrices";
import { useLocalizedSentenceDict } from "../../../hooks/useSentenceDict";

function ShippingDeadlines({ popup }) {
  const countryCode = useCurrentCountryCode();
  const dict = useLocalizedSentenceDict();

  const deadlineCountry = useMemo(() => {
    if (countryCode && popup?.deadlines?.internal?.content) {
      let jsonDeadline = JSON.parse(popup.deadlines.internal.content)[countryCode];
      if (!jsonDeadline) {
        jsonDeadline = JSON.parse(popup.deadlines.internal.content).DEFAULT;
      }
      if (jsonDeadline) {
        return jsonDeadline;
      }
    }
    return null;
  }, [countryCode, popup.deadlines]);

  if (!deadlineCountry) {
    return null;
  }

  return (
    <>
      <p className="al_p mt-[50px] mb-[20px]">{dict.get("Order deadlines")}:</p>
      <div className="block desktop:hidden">
        {deadlineCountry && deadlineCountry.standard && (
          <>
            <p className="al_p al_p--bold mt-[4px]">{dict.get("Standard")}*</p>
            <p className="al_p mb-[16px]">{deadlineCountry.standard}</p>
          </>
        )}

        {deadlineCountry && deadlineCountry.express && (
          <>
            <p className="al_p al_p--bold mt-[4px]">{dict.get("Express")}*</p>
            <p className="al_p mb-[16px]">{deadlineCountry.express}</p>
          </>
        )}
      </div>
      <div className="hidden desktop:flex desktop:justify-between desktop:mb-[40px]">
        {deadlineCountry && deadlineCountry.standard ? (
          <div className="w-[48%]">
            <p className="al_p al_p--bold">{dict.get("Standard")}*</p>
            <p className="al_p">{deadlineCountry.standard}</p>
          </div>
        ) : null}

        {deadlineCountry && deadlineCountry.express && (
          <div className="w-[48%]">
            <p className="al_p al_p--bold">{dict.get("Express")}*</p>
            <p className="al_p">{deadlineCountry.express}</p>
          </div>
        )}
      </div>
    </>
  );
}

export default ShippingDeadlines;

ShippingDeadlines.propTypes = {
  popup: PropTypes.shape({
    deadlines: PropTypes.shape({
      internal: PropTypes.shape({
        content: PropTypes.string,
      }),
    }),
  }),
};
